module.exports = __webpack_public_path__ + "img/Firning-slattefors.9b97b003.jpg";